import React from 'react';
import SectionWrapper from './section-wrapper';
import Container from './container';

const ListContainer = (props) => {
  switch (props.CurrentPageProps.PageTypeName) {
    case 'ArticlePage':
      return <Container {...props} />;
    default:
      return (
        <SectionWrapper>
          <Container {...props} hasSectionWrapper={true} />
        </SectionWrapper>
      );
  }
};

export default ListContainer;
